var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.49999H10.1685C9.95201 8.7795 9.28999 8.25 8.50001 8.25C7.71002 8.25 7.0485 8.7795 6.83152 9.49999H0.499992C0.223992 9.49999 0 9.72401 0 10C0 10.276 0.223992 10.5 0.499992 10.5H6.83149C7.04798 11.2205 7.71 11.75 8.49998 11.75C9.28997 11.75 9.95149 11.2205 10.1685 10.5H11.5C11.7765 10.5 12 10.276 12 10C12 9.72401 11.7765 9.49999 11.5 9.49999ZM8.50001 10.75C8.0865 10.75 7.75001 10.4135 7.75001 10C7.75001 9.5865 8.0865 9.25001 8.50001 9.25001C8.91352 9.25001 9.25001 9.5865 9.25001 10C9.25001 10.4135 8.91349 10.75 8.50001 10.75Z",
    fill: "#394DC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.49999H10.1685C9.95149 0.7795 9.28999 0.25 8.50001 0.25C7.71002 0.25 7.0485 0.7795 6.83149 1.49999H0.499992C0.223992 1.49999 0 1.72398 0 1.99998C0 2.27598 0.223992 2.49998 0.499992 2.49998H6.83149C7.0485 3.22049 7.71 3.74999 8.50001 3.74999C9.29002 3.74999 9.95152 3.22049 10.1685 2.5H11.5C11.7765 2.5 12 2.27601 12 2.00001C12 1.72401 11.7765 1.49999 11.5 1.49999ZM8.50001 2.74998C8.0865 2.74998 7.75001 2.41349 7.75001 1.99998C7.75001 1.58648 8.0865 1.24998 8.50001 1.24998C8.91352 1.24998 9.25001 1.58648 9.25001 1.99998C9.25001 2.41349 8.91349 2.74998 8.50001 2.74998Z",
    fill: "#394DC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.49999H5.16851C4.9515 4.7795 4.29 4.25 3.50002 4.25C2.71003 4.25 2.04851 4.7795 1.83152 5.49999H0.499992C0.223992 5.49999 0 5.72398 0 5.99998C0 6.27598 0.223992 6.49998 0.499992 6.49998H1.8315C2.04851 7.22047 2.71001 7.74997 3.49999 7.74997C4.28998 7.74997 4.9515 7.22047 5.16848 6.49998H11.5C11.7765 6.49998 12 6.27598 12 5.99998C12 5.72398 11.7765 5.49999 11.5 5.49999ZM3.49999 6.74998C3.08648 6.74998 2.74999 6.41349 2.74999 5.99998C2.74999 5.58648 3.08648 5.24998 3.49999 5.24998C3.9135 5.24998 4.24999 5.58648 4.24999 5.99998C4.24999 6.41349 3.9135 6.74998 3.49999 6.74998Z",
    fill: "#394DC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.f03f0d55a7f3320864ec1161fd8ab0ff.svg";
export { ForwardRef as ReactComponent };